module.exports = __webpack_public_path__ + "assets/icons/ic_duplicate_24px.svg";